import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { PermissionConst } from 'src/app/core/models/permission-const.model';
import { TriggerModel } from 'src/app/core/models/triggers.model';
import { RegistersService } from 'src/app/core/services/registers.service';
import { SessionManagerService } from 'src/app/core/services/session-manager.service';
import { ConfirmationModalComponent } from 'src/app/shared/renderers/components/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-triggers-form',
  templateUrl: './triggers-form.component.html',
  styleUrls: ['./triggers-form.component.scss']
})
export class TriggersFormComponent implements OnInit {

  formGroup = this.fb.group({
    id: [],
    trigger: ['', [Validators.required]],
    stop_trigger: [''],
    case_sensitive: [false],
    contains: [false]
  });

  id!: number;
  loadingPage: boolean = false;
  trigger!: TriggerModel;

  isRegister: boolean = true;

  submitting: boolean = false;
  submittingRemove: boolean = false;
  removeButton?: String = "Desativar";
  submitButton?: String = "Salvar";

  button: boolean = false;
  registerSuccess: boolean = false;

  constructor(private registersService: RegistersService, private router: Router, private fb: FormBuilder,
    private activatedRoute: ActivatedRoute, config: NgbModalConfig, private modalService: NgbModal,
    private sessionManager: SessionManagerService, private toast: ToastrService) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      if (this.id) {
        this.isRegister = false;
        this.fetchTrigger();
      }
    })
  }

  get canSave() {
    if (this.id) {
      return this.sessionManager.getUserPermission(PermissionConst.add_chatbottrigger);
    } else {
      return this.sessionManager.getUserPermission(PermissionConst.change_chatbottrigger);
    }
  }

  get canRemove() {
    return this.sessionManager.getUserPermission(PermissionConst.remove_chatbottrigger);
  }

  cancelHandler() {
    this.router.navigate(['/dashboard/registers/triggers'])
  }

  submitHandler() {
    this.submitting = true;
    let triggerData = this.formGroup.getRawValue() as TriggerModel;
    if (triggerData.stop_trigger == null) {
      triggerData.stop_trigger = '';
    }
    if (this.isRegister) this.triggerRegister(triggerData);
    else this.triggerEdit(triggerData);
  }

  removeHandler() {
    this.submittingRemove = true;
    const modalRef = this.modalService.open(ConfirmationModalComponent, { centered: true });
    modalRef.componentInstance.text = "Deseja desativar este gatilho?";
    modalRef.result.then((result) => {
      if (result == true) {
        this.triggerRemove();
      }
      this.submittingRemove = false;
    })
  }

  triggerRegister(triggerData: TriggerModel) {
    triggerData.id = undefined;
    this.registersService.triggersRegister(triggerData).subscribe(response => {
      this.registerSuccess = true;
      this.toast.success("Gatilho criado com sucesso", "Sucesso");
      this.router.navigate(['/dashboard/registers/triggers']);
    }, error => {
      const response = error as HttpErrorResponse;
      this.mapErrorResponse(response);
      this.submitting = false;
    });
  }

  triggerEdit(triggerData: TriggerModel) {
    triggerData.is_active = true;
    this.registersService.triggersEdit(triggerData).subscribe(trigger => {
      this.registerSuccess = true;
      this.toast.success("Gatilho alterado com sucesso", "Sucesso");
      this.router.navigate(['/dashboard/registers/triggers']);
    }, error => {
      const response = error as HttpErrorResponse;
      this.mapErrorResponse(response);
      this.submitting = false;
    });
  }

   triggerRemove() {
    this.registersService.triggersRemove(this.id).subscribe(response => {
      this.toast.success("Gatilho removido com sucesso", "Sucesso");
      this.router.navigate(['/dashboard/registers/triggers']);
    }, (error) => {
      const response = error as HttpErrorResponse;
      this.mapErrorResponse(response);
      this.submittingRemove = false;
    });
  }

  fetchTrigger() {
    this.loadingPage = true;
    this.registersService.triggersGet(this.id).subscribe(trigger => {
      this.trigger = trigger;
      this.formGroup.patchValue(trigger);
      this.loadingPage = false;
      if (trigger.is_active) {
        this.button = true;
        this.removeButton = "Desativar";
        this.submitButton = "Salvar";
      } else {
        this.button = false;
        this.submitButton = "Reativar";
        this.formGroup.disable();
      }
    }, error => {
      const response = error as HttpErrorResponse;
      this.mapErrorResponse(response);
    });
  }

  zeroTrigger() {
    this.registersService.zeroTrigger(this.id).subscribe(response => {
      this.toast.success('Gatilho zerado com sucesso.', 'Sucesso');
    }, (errorResponse: HttpErrorResponse) => {
      this.mapErrorResponse(errorResponse);
    });
  }

  mapErrorResponse(errorResponse: HttpErrorResponse) {
    if (errorResponse.error["detail"]) {
      this.toast.error(errorResponse.error["detail"], "Erro");
    } else {
      this.setFormErrors(errorResponse);
    }
  }

  setFormErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.error["trigger"]) this.formGroup.get("trigger")?.setErrors({ response: errorResponse.error['trigger'] });
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    if ((this.formGroup.dirty || this.submitting) && !this.registerSuccess && this.isRegister) {
      const modalRef = this.modalService.open(ConfirmationModalComponent, { centered: true });
      modalRef.componentInstance.text = "As alterações no formulário não foram salvas e serão descartadas, deseja prosseguir?";
      return modalRef.result
    } else
      return true;
  };
}
